"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spoiler = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var hooks_1 = require("../../../mantine-hooks/src");
var Button_1 = require("../Button/Button");
var Spoiler_styles_1 = __importDefault(require("./Spoiler.styles"));
function Spoiler(_a) {
    var className = _a.className, children = _a.children, _b = _a.maxHeight, maxHeight = _b === void 0 ? 100 : _b, hideLabel = _a.hideLabel, showLabel = _a.showLabel, themeOverride = _a.themeOverride, _c = _a.transitionDuration, transitionDuration = _c === void 0 ? 200 : _c, controlRef = _a.controlRef, others = __rest(_a, ["className", "children", "maxHeight", "hideLabel", "showLabel", "themeOverride", "transitionDuration", "controlRef"]);
    var classes = Spoiler_styles_1.default({
        transitionDuration: !hooks_1.useReducedMotion() && transitionDuration,
        theme: theme_1.useMantineTheme(themeOverride),
    });
    var _d = react_1.useState(false), show = _d[0], setShowState = _d[1];
    var _e = react_1.useState(false), spoiler = _e[0], setSpoilerState = _e[1];
    var contentRef = react_1.useRef(null);
    var spoilerMoreContent = show ? hideLabel : showLabel;
    react_1.useEffect(function () {
        setSpoilerState(maxHeight < contentRef.current.clientHeight);
    }, [maxHeight, children]);
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.spoiler, className) }, others),
        react_1.default.createElement("div", { className: classes.content, style: {
                maxHeight: !show ? maxHeight : contentRef.current && contentRef.current.clientHeight,
            } },
            react_1.default.createElement("div", { ref: contentRef }, children)),
        spoiler && (react_1.default.createElement(Button_1.Button, { variant: "link", elementRef: controlRef, onClick: function () { return setShowState(function (opened) { return !opened; }); }, themeOverride: themeOverride }, spoilerMoreContent))));
}
exports.Spoiler = Spoiler;
Spoiler.displayName = '@mantine/core/Spoiler';
